import commonService from "./common-service";

class FormularyService {
  async getFormulas() {
    try {
      const response = await commonService.getFromServer(
        "EOM/CoreCivicFormulary",
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createFormula(params) {
    try {
      let response = await commonService.postToServer(
        "EOM/CoreCivicFormulary",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async uploadDocument(params) {
    try {
      const response = await commonService.postToServer(
        "EOM/CoreCivicFormulary/Upload",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async downloadDocument(params) {
    try {
      await commonService.downloadFromServer(
        "EOM/CoreCivicFormulary/Download",
        { fileName: "CoreCivicFormulary.xlsx" }
      );
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async updateFormula(params) {
    try {
      let response = await commonService.updateToServer(
        "EOM/CoreCivicFormulary/" + params.id,
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getFormula(id) {
    try {
      const response = await commonService.getFromServer(
        "EOM/CoreCivicFormulary/" + id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.msg.error);
    }
  }

  async deleteFormula(id) {
    try {
      const response = await commonService.deleteToServer(
        "EOM/CoreCivicFormulary/" + id,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting drug");
      }
    } catch (e) {
      throw new Error("Error deleting drug");
    }
  }
}

export default new FormularyService();
